// extracted by css-extract-rspack-plugin
export default {"submitButton":"U0h1Y"};